import { Button, Modal } from '@warp-ds/react';
import { OnboardingModalType } from '../../../types/uiTypes';
import { getStepIllustration } from './Illustrations';
import { useSidebarContext } from '../../../state/SidebarContext';

type Props = {
    uiText: OnboardingModalType;
    isOpen: boolean;
    closeModal: () => void;
};

/**
 * A modal that will introduce the buyer with three easy steps how the ship-it solution works.
 */
const OnboardingModal = ({ uiText, isOpen, closeModal }: Props) => {
    const { brand, device } = useSidebarContext();

    return (
        <Modal
            open={isOpen}
            right={true}
            onDismiss={closeModal}
            className="children:children:mt-0!"
            title={<h1 className="h4 sm:h3 flex items-center mb-0">{uiText.title}</h1>}
            footer={
                <Button primary className="mt-16 text-s!" onClick={closeModal}>
                    {uiText.actions.close.text}
                </Button>
            }
        >
            <>
                <a className="block underline font-bold py-16" href={uiText.actions.readMore.link}>
                    {uiText.actions.readMore.text}
                </a>

                <ol className="mb-16!">
                    {uiText.details.map((detail, index) => {
                        const { title, text, altText } = detail;
                        const stepNumber = index + 1;
                        return (
                            <li key={index}>
                                {getStepIllustration(stepNumber, brand, device, altText)}
                                <div className="relative mt-8 mb-16 pl-16">
                                    <h2 className="t4">
                                        <span className="absolute top-0 left-0">{stepNumber}.</span>
                                        {title}
                                    </h2>
                                    <p>{text}</p>
                                </div>
                            </li>
                        );
                    })}
                </ol>
            </>
        </Modal>
    );
};

export default OnboardingModal;
